import config from 'company-management/config'

const customerApi = `${config.apiHost}/oem-group-broadcast`
const authApi = `${config.apiHost}/oem-auth`

export default {
    // 获取所有机器人列表
    getAllRobotList: {
        url: `${customerApi}/public/broadcasts/failure-records/related-customers`,
        type: 'GET',
    },
    // 失败记录-列表
    getFailedList: {
        url: `${customerApi}/public/broadcasts/failure-records`,
        type: 'GET',
    },

    // 失败记录-统计信息
    getFailedStat: {
        url: `${customerApi}/public/broadcasts/failure-records/statistics`,
        type: 'GET',
    },

    // 导出
    exportFailed: {
        url: `${customerApi}/public/broadcasts/failure-records/download`,
        type: 'GET',
    },

    // 商家
    companies: {
        url: `${authApi}/admin/companies`,
        type: 'GET',
    },
}
